module.exports = __webpack_public_path__ + "img/stack07.3f781f95.svg";